import { createSlice } from "@reduxjs/toolkit";

export interface Advertisement {
  type: "info" | "warning";
  message: string;
  content: string;
}

export interface InterfaceState {
  advertisement: Advertisement | null;
  closeAccordionState: number;
}

const initialState: InterfaceState = {
  advertisement: null,
  closeAccordionState: -1,
};

const interfaceSlice = createSlice({
  name: "interface",
  initialState,
  reducers: {
    setAdvertisement(state, action) {
      state.advertisement = action.payload;
    },
    closeAccordion: (state, action) => {
      state.closeAccordionState = action.payload;
    },
  },
});

export const { setAdvertisement, closeAccordion } = interfaceSlice.actions;
export default interfaceSlice.reducer;
